__webpack_require__.p = "https://ui.prod.eu-west-1.urc.advertising.amazon.dev/";